var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiBreakfast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--breakfast_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--breakfast_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.323 11.618c.279.139.514.107.705-.097.192-.203.218-.43.08-.682l-1.12-1.98-.906 2.15 1.241.609zm-3.436-.587h1.095l1.613-3.776c.067-.16.072-.292.013-.394a.542.542 0 00-.277-.231l-1.333-.505a.593.593 0 00-.44.002.373.373 0 00-.245.311l-.426 4.593zm-4.869 0h1.095l-.426-4.617a.357.357 0 00-.239-.291.623.623 0 00-.445.002l-1.334.505c-.144.056-.235.14-.271.255a.579.579 0 00.033.395l1.587 3.75zm-2.34.587l1.24-.609-.892-2.15-1.134 2.005c-.147.255-.119.477.083.666.202.19.436.219.702.088zm4.435-.587h1.774L9.4 5.558a.407.407 0 00-.113-.366.514.514 0 00-.387-.15H7.1a.54.54 0 00-.357.141.382.382 0 00-.143.35l.513 5.498zm-4.786 1.588a1.43 1.43 0 01-1.067-.436 1.436 1.436 0 01-.375-1.399c.035-.117.08-.23.136-.342L2.526 7.72a1.61 1.61 0 01-.019-1.163c.139-.384.402-.652.79-.804l1.334-.504c.173-.065.347-.102.524-.113.177-.011.343.02.499.091.096-.317.274-.585.535-.804.26-.219.567-.328.92-.328H8.9c.351 0 .658.106.921.32.263.212.447.475.55.788a.855.855 0 01.48-.075c.177.02.35.06.518.12l1.334.505c.401.152.678.419.83.8.152.382.137.76-.046 1.135l1.505 2.721c.058.104.104.21.138.319.033.109.05.223.05.34 0 .433-.157.8-.47 1.1-.314.3-.698.45-1.153.45-.112 0-.22-.012-.327-.036a1.664 1.664 0 01-.32-.11l-1.059-.497H4.128l-.972.485a1.256 1.256 0 01-.403.128c-.142.02-.284.03-.426.03z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--breakfast-29762013dc1cf75e3a3f2aa74c6a3e6b.svg";
export { SvgIconUiBreakfast as Component };